import Vue from "vue";
import VueRouter from 'vue-router'
Vue.use(VueRouter);
const router = new VueRouter({
    mode: 'hash',
    routes: [
        {
            path: "/home",
            name: 'home',
            component: () => import("@/view/homePageJsClient.vue"),
        },
        {
            path: "/",
            redirect: '/home',
        },
        {
            path: "/success/:tradeNo",
            name: 'success',
            component: ()=>import('@/view/success.vue'),
        },
        {
            path: "/failure/:tradeNo",
            name: 'failure',
            component: ()=>import('@/view/failure.vue'),
        },
        {
            path: "/loading/:tradeNo?",
            name: 'loading',
            component: ()=>import('@/view/loading.vue'),
        },
        {
            path: "/simulate-callback",
            name: 'SimulateCallback',
            component: ()=>import('@/view/showcase/SimulateCallback.vue'),
        },
        {
            path: "/payment-link-callback",
            name: 'PaymentLinkCallback',
            component: ()=>import('@/view/showcase/PaymentLinkCallback.vue'),
        },
    ]
})

export default router
